import { FunctionComponent, PropsWithChildren } from 'react';
import { DisclosureGroupProps } from './DisclosureGroupProps';

export const DisclosureGroup: FunctionComponent<PropsWithChildren<DisclosureGroupProps>> = ({ title, children }) => {
  return (
    <details>
      <summary className="font-medium cursor-pointer text-text">{title}</summary>
      {children ? <div className="pt-2 pb-2">{children}</div> : undefined}
    </details>
  );
};
